import React, { Component } from 'react';

import FadeIn from '../_core/components/FadeIn';
import ScrollTo from '../_core/components/ScrollTo';

import Template from '../_core/controllers/Template';

import Data from '../_core/models/Data';
import Entry from '../_core/models/Entry';

import settings from '../_settings';

import {Breakpoints} from '../_core/utils';

// Project
import Project from '../components/';

class Layout extends Component {

	ref = {};

	constructor(props) {
		super(props);
		this.state = {};
	}

	componentDidMount() {

	}

	componentWillUnmount() {

	}

	setRef = (label,el) => {
		this.ref[label] = el;
	}

	
	/*

		RENDER

	*/

	render() {

		return (
			<FadeIn duration={1.5}>
			
				<div data-layout className="Site-page">

					{/* Auto Scroll Reset */}
					<ScrollTo useHistory={true} ignore={({pathname},history) => { return window.location.hash }} />

					{/* Template */}
					<div className="Site-template">
						<Template />
					</div>

					

					{/* Footer */}
					<div className="Site-foot">
						<Project.Footer />
					</div>

					<Project.InteractiveMisrep />

	            </div>
	            
            </FadeIn>

		);

	}
}

export default Layout;



// WEBPACK FOOTER //
// ./src/js/templates/_layout.js